import axios, { AxiosError, AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiUrl, oldUrl } from './config';

export type HTTPMethod = 'get' | 'post' | 'delete' | 'put' | 'patch';

export interface JsonBody {
  // tslint:disable-next-line no-any
  [key: string]: any;
}

export interface RequestOptions {
  apiVersion?: 'api' | 'old';
  withHeaders?: boolean;
  headers?: object;
  withCredentials?: boolean;
  responseType?: any;
}

export interface Request {
  method: HTTPMethod;
  url: string;
  body?: JsonBody;
}

const getAPI = () => {
  return {
    api: apiUrl(),
    old: oldUrl(),
  };
};

const buildRequest = (request: Request, configData: RequestOptions, withCredentials = true) => {
  const { body, method, url } = request;
  const { apiVersion, headers, responseType } = configData;
  const api = getAPI();

  const contentType = body instanceof FormData ? 'multipart/form-data' : 'application/json';

  const defaultHeaders = {
    'Content-Type': contentType,
  };

  const apiUrl = api[apiVersion ?? 'api'];
  const requestConfig: AxiosRequestConfig = {
    baseURL: apiUrl,
    data: body,
    headers: { ...headers, ...defaultHeaders },
    method,
    url,
    responseType,
    withCredentials: withCredentials || true,
  };

  return requestConfig;
};

export const defaultResponse: Partial<AxiosError['response']> = {
  status: 500,
  data: {
    error: 'Server error',
  },
};

export const formatError = (responseError: AxiosError) => {
  const response: any = responseError.response || defaultResponse;
  //@ts-ignore
  const errors =
    (response.data && (response.data.error || response.data.message || response.data)) || {};

  return {
    code: response.status,
    message: errors,
  };
};

export const makeRequest = async (request: Request, configData: RequestOptions) => {
  const requestConfig = buildRequest(request, configData);

  return new Promise((resolve, reject) => {
    const axiosRequest: AxiosPromise = axios(requestConfig);
    axiosRequest
      .then((response: AxiosResponse) => {
        if (configData.withHeaders) {
          resolve(response);
        } else if (response?.data instanceof Blob) {
          resolve(response);
        } else {
          if (response.data?.code !== '1000') {
            reject({
              code: response?.data?.code,
              message: response?.data?.message,
              errors: response?.data?.errors,
            });
          } else {
            resolve(response.data);
          }
        }
      })
      .catch((error: AxiosError) => {
        reject(formatError(error));
      });
  });
};
